const ELEMENTS_TO_REMOVE: Array<string> = [
  'ft-my-rewards',
  'ft-wheel-component',
  'ft-notifications-center',
];

const SCRIPTS_TO_REMOVE: Array<string> = [
  'https://lib-staging.rewards.tech/wc/rewards-main.umd.cjs',
  'https://lib-staging.rewards.tech/lib/js/fasttrack-crm-app.js',
  'https://lib-staging.rewards.tech/lib/js/fasttrack-crm-chunk-vendors.js',
];

export const cleanupExistingFastTrackElements = () => {
  document.querySelectorAll('.ft-rewards-wrapper').forEach(el => el.remove());
  ELEMENTS_TO_REMOVE.forEach(tagName => document.querySelectorAll(tagName).forEach(el => el.remove()));
  document.querySelectorAll('script').forEach(script => {
    const isExistingScript = script.src && SCRIPTS_TO_REMOVE.some(url => script.src.includes(url));
    if (isExistingScript) script.remove();
  });
};